import React from 'react';
import { TrendingUp, Zap, BarChart3, LineChart } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import './BenefitsStrip.css';

const BenefitsStrip = () => {
  const { language } = useLanguage();

  const benefits = [
    {
      icon: TrendingUp,
      title: language === 'es' ? 'Más visibilidad' : 'More visibility',
      description: language === 'es' 
        ? 'Atrae nuevas oportunidades con una presencia digital estratégica.'
        : 'Attract new opportunities with a strategic digital presence.'
    },
    {
      icon: Zap,
      title: language === 'es' ? 'Menos trabajo manual' : 'Less manual work',
      description: language === 'es'
        ? 'Automatiza procesos y reduce tareas repetitivas.'
        : 'Automate processes and reduce repetitive tasks.'
    },
    {
      icon: BarChart3,
      title: language === 'es' ? 'Mejor control' : 'Better control',
      description: language === 'es'
        ? 'Organiza información y toma decisiones con datos.'
        : 'Organize information and make data-driven decisions.'
    },
    {
      icon: LineChart,
      title: language === 'es' ? 'Crecimiento sostenible' : 'Sustainable growth',
      description: language === 'es'
        ? 'Implementa soluciones que pueden evolucionar con tu negocio.'
        : 'Implement solutions that can evolve with your business.'
    }
  ];

  return (
    <section className="benefits-strip">
      <div className="container">
        <div className="benefits-grid">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div key={index} className="benefit-card">
                <div className="benefit-icon-wrapper">
                  <Icon size={28} className="benefit-icon" />
                </div>
                <h3 className="benefit-title">{benefit.title}</h3>
                <p className="benefit-description">{benefit.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BenefitsStrip;